import React from "react";
import Modal from "react-modal";

import type { MessageBoxParams } from "../../store/state/modals/reducer";

interface Props extends MessageBoxParams {
  isOpen: boolean;
  onClose: () => void;
}

export default function MessageBox(props: Props): JSX.Element {
  const { isOpen, onClose, title, message, buttonText } = props;
  return (
    <Modal
      isOpen={isOpen}
      appElement={window.__myapp_container}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      overlayClassName="modal-overlay"
      className="modal-content"
      style={{ content: { maxWidth: "450px" } }}
    >
      <div className="modal-header">
        <h3>{title}</h3>
      </div>
      <div className="modal-message">
        {message.split(/\n/).map((x, idx) => (
          // This is a read-only list, no reason to use anything more complicated than
          // an index
          <p key={idx}>{x}</p>
        ))}
      </div>
      <div className="button-align">
        <button type="button" className="btn-control btn-control_brown wider" onClick={onClose}>
          {buttonText?.ok || "OK"}
        </button>
      </div>
    </Modal>
  );
}
